import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import EudrDashboardService from 'src/modules/3rd-party-management/apis/admin/EudrDashboardService';

export const EUDR_TOP_DEFORESTATION_HOTSPOT_REGIONS_QUERY_KEY = '3rd-party-management-fetch-eudr-top-deforestation-hotspot-regions';

const useTopDeforestationHotspotRegions = ({
    t,
}) => {
    return useQuery({
        queryKey: [EUDR_TOP_DEFORESTATION_HOTSPOT_REGIONS_QUERY_KEY],
        queryFn: async () => {
            const service = EudrDashboardService.getInstance();

            return await service.fetchTopDeforestationHotspotRegions();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching EUDR top deforestation hotspot regions data.'), {
                type: 'error',
            });
        },
    });
};

export default useTopDeforestationHotspotRegions;
